module.exports = __webpack_public_path__ + "media/stylesheets/images/main/star/star@2x-5bd1882308b9d7f470e0397e14f5c89e.png";